import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyApOhV_Wa_VHgU63DxFH8I9NHWMyDpMMPI",
    authDomain: "web-services-ipumon.firebaseapp.com",
    projectId: "web-services-ipumon",
    storageBucket: "web-services-ipumon.appspot.com",
    messagingSenderId: "227085420677",
    appId: "1:227085420677:web:e15984c1c44854cfd481ec"
  };
const app = initializeApp(firebaseConfig);


// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { auth, storage }
export default db